import type { ModalRouteGateProps } from "./router-modal-routes.type";

import { Navigate, useLocation } from "react-router";

import { usePageModalLocationState } from "@/modules/page-modal";

export const ModalRouteGate = ({
  parentPath,
  children,
}: ModalRouteGateProps) => {
  const location = useLocation();
  const { backgroundLocation } = usePageModalLocationState();

  // If page is supposed to be a modal but `pageModal` props do not exist in
  // location object, redirect user to the same page with `pageModal` props:
  // -> `backgroundLocation`: is the page displayed on modal background
  //     and the redirect url on modal close (home page by default)
  // doc: https://v5.reactrouter.com/web/example/modal-gallery
  if (!backgroundLocation) {
    const parent = parentPath ?? "/";
    return (
      <Navigate
        to={location.pathname}
        state={{ pageModal: { backgroundLocation: { pathname: parent } } }}
        replace
      />
    );
  }

  // Otherwise, render the route content
  return children;
};
